import { deleteRequest, putRequest, postRequest } from "../../api/categoryFeild/modal.js";
import { Delete } from "@mui/icons-material";
import { Alert, Box, Button, CircularProgress, IconButton, Switch } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Dropdown, Modal, NumberInput } from "../../../../shared/ui/common/index.js";

import Confirm from "../../../../shared/ui/modals/Confirm.jsx";


import { logout } from "../../../../shared/state/slices/user.js";
const CategoryFeilds = ({
  open,
  close,
  data = {},
  forEdit,
  setAllRows,
  allRows,
  allFeilds,
  feilds,
}) => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.user);
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedProductImage, setselectedProductImage] = useState();
  const { userPermissions } = useSelector((state) => state.relationals);
  const [catSearchWord, setCatSearchWord] = useState("");
  const [category, setCategory] = useState("");
  const [loading, setLoading] = useState(false);
  const [prevData, setPrevData] = useState({});
  const [openDelete, setOpenDelete] = useState(false);
  const [showingCats, setShowingCats] = useState([]);
  useEffect(() => {
    setShowingCats(allFeilds);
  }, [allFeilds]);
  useEffect(() => {
    const notFilteredRows = [...showingCats];
    let afterFilterRows = notFilteredRows.filter((row) =>
      row.title.toLowerCase().includes(catSearchWord.toLowerCase())
    );
    setShowingCats(afterFilterRows);
  }, [catSearchWord]);
  // set data
  useEffect(() => {
    if (forEdit) {
      setPrevData({
        ...data,
      });
    } else {
      resetData();
    }
  }, [allRows, data, forEdit, allFeilds]);
  const resetData = () => {
    setPrevData(data);
  };
  const deleteCategory = () => {
    if (data) {
      setLoading(true);
      deleteRequest(searchParams, data, token)
        .then((res) => {
          setLoading(false);
          setOpenDelete(false);
          var temp = [...allRows];
          var newData = temp.filter((item) => item.id !== data.id);
          setAllRows(newData);
          close();
          toast.success("با موفقیت حذف شد");
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err.response?.data?.message);
          setOpenDelete(false);
          if (err.response.status === 401) {
            dispatch(logout());
          }
        });
    }
  };
  const editItem = () => {
    var temp = [...allRows];

    /*     const datas ={}; */
    /*     formData.append("fieldId", prevData?.fieldId);
    formData.append("categoryId", id);
    formData.append("priority", prevData?.priority); */
    var datas = {
      fieldId: prevData?.fieldId,
      categoryId: id,
      priority: prevData?.priority,
      type: prevData?.type,
    };
    if (forEdit) {
      datas = { ...datas, id: prevData?.id };
      /*   formData.append("id", prevData?.id); */
    }
    /*     if (prevData?.avatar) formData.append("files", prevData?.avatar);
    if (selectedProductImage)
      formData.append("fromGallery", selectedProductImage); */
    setLoading(true);
    if (forEdit) {
      putRequest(searchParams, datas, token)
        .then((res) => {
          setLoading(false);
          toast.success("با موفقیت ویرایش شد");
          var index = temp.findIndex((item) => item.id === data.id);
          temp[index] = res.data.data;
          setAllRows(temp);
          close();
          resetData();
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err.response?.data?.message);

          if (err.response.status === 401) {
            dispatch(logout());
          }
        });
    } else {
      postRequest(searchParams, datas, token)
        .then((res) => {
          temp.unshift(res.data.data);

          setAllRows(temp);
          setLoading(false);
          toast.success("با موفقیت اضافه شد");
          close();
          resetData();
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err.response?.data?.message);

          if (err.response.status === 401) {
            dispatch(logout());
          }
        });
    }
  };
  console.log(prevData, "data");
  return (
    <Modal
      open={open}
      close={close}
      title={` ${forEdit ? "ویرایش" : "افزودن"}    مقدار فیلد دسته بندی
    `}
    >
      {searchParams.get("isParent") === "true" && (
        <Alert severity="info" variant="outlined">
          اضافه کردن فیلد به دسته بندی پدر به تمامی دسته بندی فرزند نیز اضافه
          میشود
        </Alert>
      )}
      <Dropdown
        value={feilds?.find((item) => item.id === prevData?.fieldId)}
        change={(e) => setPrevData({ ...prevData, fieldId: e?.id })}
        data={feilds}
        title="فیلد"
        emptyValue={true}
      />
      <NumberInput
        value={prevData?.priority}
        change={(e) => setPrevData({ ...prevData, priority: e })}
        label="الویت"
      />
      {searchParams.get("isParent") !== "true" && (
        <div className="flex gap-5 items-center">
          <span>     منتسب / غیر منتسب:‌</span>
          <Switch
            checked={prevData?.type === 1}
            onClick={() =>
              setPrevData({ ...prevData, type: prevData?.type === 1 ? 0 : 1 })
            }
          />
        </div>
      )}
      {/*       <UploadImage
        file={prevData?.avatar}
        change={(e) => setPrevData({ ...prevData, avatar: e })}
        address={data.galleryId ? data.galleryId : false}
        selectedProductImage={selectedProductImage}
        setselectedProductImage={setselectedProductImage}
      /> */}
      <Box sx={{ display: "flex" }}>
        {forEdit && (
          <IconButton onClick={() => setOpenDelete(true)}>
            <Delete color="error" />
          </IconButton>
        )}
        <div style={{ flexGrow: 1 }} />
        <Button
          variant="contained"
          color="primary"
          onClick={editItem}
          disabled={loading}
        >
          {loading ? <CircularProgress /> : <>ثبت اطلاعات</>}
        </Button>
      </Box>
      <Confirm
        message="آیا از حذف این دسته بندی اطمینان دارید؟"
        close={() => setOpenDelete(false)}
        submit={deleteCategory}
        open={openDelete}
      />
    </Modal>
  );
};

export default CategoryFeilds;
